import React from "react";
import { Form } from "react-bootstrap";

const InputFloat = React.forwardRef(({ value, onFloat, onChange, locale = 'pt-br', fractions = 2, ...rest }, ref) => {

    let displayValue = "";
    if(!value || isNaN(value)) displayValue = "";
    else displayValue = parseFloat(value).toLocaleString(locale, { minimumFractionDigits: fractions});

    function handleChange(e) {
        let inputValue = e.target.value;
        let rawValue = 0.0;
        
        
        rawValue = parseFloat(inputValue.replace(/\D/g, ''));
        if((rawValue || rawValue === 0) && !isNaN(rawValue)) {
            if(fractions > 0) rawValue /= Math.pow(10, fractions);
            if(inputValue.indexOf('-') >= 0) rawValue *= -1
            if(inputValue.indexOf('+') >= 0 && rawValue < 0) rawValue *= -1;
        } else rawValue = undefined;


        if(onChange) onChange({ target: { ...e.target, value: rawValue }});
        if(onFloat) onFloat(rawValue);
    }

    return (
        <>
            <Form.Control
                value={displayValue}
                onChange={handleChange}
                ref={ref}
                {...rest}
            />
        </>
    )

});

export default InputFloat;